import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Col, Row, InputNumber, Radio} from 'antd';
import {getProduct, getProductStock} from './actions';
import Barcode from "../common/Barcode";

import './ProductLabelPage.css';
import MoneyDisplay from "../common/MoneyDisplay";
import {decodeParams} from "../utils/params";

const labelStyle = `
.label-size-0 {
    width: 2.05in;
    height: 1.17in;
    margin: 0;
}

.label-size-1 {
    width: 1.3in;
    height: 0.42in;
    margin: 0;
}

.product-label {
    font-family: Monospaced, sans-serif;
    text-align: left;
    page-break-after: always;
    position: relative;
    box-sizing: content-box;
}

.font-size-0 {
    font-size: 10pt;
    line-height: 1.3em;
}

.font-size-1 {
    font-size: 9pt;
    line-height: 1.2em;
}

.product-name, .product-quantity {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-price {
    font-weight: bold;
}

.product-quantity {
    float: right;
}

.label-size-0 .barcode-wrapper {
    padding: 1.25mm 0;
}

.barcode-wrapper {
    line-height: 0;
}

.barcode-wrapper .barcode {
    width: 100%;
}

.label-sku {
    text-align: center;
    font-size: 0.9em;
}

.label-size-1 .label-sku {
    line-height: 1em;
}

.label-size-1 .label-text, .label-size-1 .label-lot-number {
    display: none;
}
`;

const ButtonGroup = Button.Group;

class ProductLabelPage extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    productLoading: PropTypes.bool.isRequired,
    product: PropTypes.object.isRequired,
    productStock: PropTypes.object,

    getProduct: PropTypes.func.isRequired,
    getProductStock: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.labelRef = React.createRef();
    this.state = {
      quantity: 1,
      labelSizeId: 0,
      fontSizeId: 0,
    };
  }

  componentDidMount() {
    this._loadProduct();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.productId !== prevProps.match.params.productId) this._loadProduct();
  }

  _loadProduct() {
    const {productId, sku} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
    this.props.getProductStock({productId, sku: sku === '-' ? '' : sku});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  static getQuantity({packageQuantity, unit}) {
    return `${packageQuantity} ${unit}`;
  }

  handlePrint = () => {
    const iframe = document.createElement('iframe');
    function closePrint() {
      document.body.removeChild(iframe);
    }
    const qty = this.state.quantity;
    const labelHtml = this.labelRef.current.innerHTML;
    iframe.onload = function() {
      const win = this.contentWindow;
      const doc = win.document;
      doc.open();
      doc.write('<html><head><title>Label</title><style type="text/css">' + labelStyle + '</style></head><body>');
      for (let i = 0; i < qty; i++) {
        doc.write(labelHtml);
      }
      doc.write('</body></html>');
      doc.close();
      win.onbeforeunload = closePrint;
      win.onafterprint = closePrint;
      win.focus();
      win.print();
    };
    iframe.style.visibility = 'hidden';
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.button = '0';
    document.body.appendChild(iframe);
  };

  handleQuantityChange = quantity => {
    this.setState({quantity});
  };

  handleLabelSizeChange = e => {
    this.setState({labelSizeId: e.target.value});
  };

  handleFontSizeChange = e => {
    this.setState({fontSizeId: e.target.value});
  };

  render() {
    const {product, productLoading, productStock} = this.props;
    const {brandName, name, salePrice} = product;
    const {quantity, labelSizeId, fontSizeId} = this.state;
    const barcode = (productStock && productStock.sku) || '';
    const lotNumber = (productStock && productStock.lotNumber) || null;
    const rowStyle = {padding: '0.5em 0'};
    const radioStyle = {
      display: 'block',
      height: '2em',
      lineHeight: '2em',
    };
    return (
      <Card title="Product Label">
        <Row style={rowStyle}>
          <Col span={8}>Label Size</Col>
          <Col span={16}>
            <Radio.Group defaultValue={labelSizeId} onChange={this.handleLabelSizeChange}>
              <Radio style={radioStyle} value={0}>2.25&quot; x 1.25&quot; Label (no margin)</Radio>
              <Radio style={radioStyle} value={1}>1.5&quot; x 0.5&quot; Label (no margin)</Radio>
            </Radio.Group>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col span={8}>Font Size</Col>
          <Col span={16}>
            <Radio.Group defaultValue={fontSizeId} onChange={this.handleFontSizeChange}>
              <Radio style={radioStyle} value={0}>Normal</Radio>
              <Radio style={radioStyle} value={1}>Small</Radio>
            </Radio.Group>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col span={8}>Preview</Col>
          <Col span={16}>
            <div ref={this.labelRef}>
              <div className={`product-label product-label-preview label-size-${labelSizeId} font-size-${fontSizeId}`}>
                <div className="label-text">
                  <div className="product-name">{brandName}</div>
                  <div className="product-name">{name}</div>
                  <div className="product-quantity">{ProductLabelPage.getQuantity(product)}</div>
                  <div className="product-price"><MoneyDisplay amount={salePrice}/></div>
                </div>
                <div className="barcode-wrapper">
                  <Barcode
                    value={barcode}
                    options={{lineColor: '#000', width: 1.9, margin: 0, height: 30, displayValue: false}}
                  />
                </div>
                <div className="label-sku">
                  {barcode}
                  {lotNumber && <span className="label-lot-number"> - (L){lotNumber}</span>}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col span={8}>Quantity:</Col>
          <Col span={16}>
            <InputNumber defaultValue={quantity} onChange={this.handleQuantityChange} />
          </Col>
        </Row>
        <ButtonGroup style={rowStyle}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={productLoading}
            onClick={this.handlePrint}
          >
            Print
          </Button>
          <Button
            htmlType="button"
            onClick={this.goBack}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  productLoading: state.product.productLoading || state.product.gettingProductStocks,
  product: state.product.product || {},
  productStock: state.product.productStock,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getProduct,
  getProductStock,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(ProductLabelPage);



// WEBPACK FOOTER //
// ./src/Product/ProductLabelPage.js